import { render, staticRenderFns } from "./PaginatorModeMultiUser.vue?vue&type=template&id=60b4b370"
import script from "./PaginatorModeMultiUser.vue?vue&type=script&lang=js"
export * from "./PaginatorModeMultiUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports